/**
 * @desc 退出
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/web/sso/loginout',
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/mock/web/sso/loginout',
  });
}
